import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import Android from '../assets/svg/projects/android-icon.svg'
import webb from '../assets/svg/projects/webb.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Leaf Vault',
        projectDesc: 'Leaf Vault is a simple, fast digital library platform that lets users browse, read, and download books all in one place.',
        tags: ['React', 'CSS', 'Supabase'],
        code: 'https://github.com/itzkavindu/leafVault',
        demo: 'https://leafvault.netlify.app',
        image: two
    },
    {
        id: 2,
        projectName: 'Doqet',
        projectDesc: 'Doqet is a minimal, personal productivity app designed to help you manage tasks, ideas, and goals in one focused space.',
        tags: ['Expo (React Native)', 'Tailwind CSS'],
        code: '',
        demo: '',
        image: one
    },
    {
        id: 3,
        projectName: 'YT Downloader',
        projectDesc: 'A YouTube Video Downloader Made to Download YouTube Videos in High Quality',
        tags: ['Python', 'CustomTkinter'],
        code: 'https://github.com/itzkavindu/ytDownloader',
        demo: 'https://github.com/itzkavindu/ytDownloader',
        image: three
    },
    {
        id: 4,
        projectName: 'Javy Digital Web',
        projectDesc: 'A sharp web presence for Javy Digital, focused on powering business success online.',
        tags: ['HTML', 'CSS', 'JS'],
        code: 'https://javy.kavindu.tech',
        demo: 'https://javy.kavindu.tech',
        image: webb
    },
    {
        id: 6,
        projectName: 'JAVI',
        projectDesc: 'JAVI helps you navigate emotions with AI-driven therapy and support',
        tags: ['React', 'Python', 'JS', 'Microsoft Azure'],
        code: '',
        demo: '',
        image: four
    },
    {
        id: 7,
        projectName: 'React Native (Expo) Onboarding Template',
        projectDesc: 'Ready-to-use onboarding screens for smooth React Native (Expo) app starts.',
        tags: ['React Native', 'Expo', 'Tailwind CSS', 'TypeScript'],
        code: '',
        demo: '',
        image: two
    },
    {
        id: 8,
        projectName: 'Moodylog',
        projectDesc: 'Moodylog is a simple, personal mood tracker that helps you reflect on your emotions and notice patterns over time.',
        tags: ['Expo (React Native)', 'Tailwind CSS'],
        code: '',
        demo: '',
        image: four
    },

]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/